import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { DxtradeOrdersHistoryQuery } from '@model/DxtradeOrderHistoryFields'

export const useDxtradeOrdersHistory = (accountCode: string, query?: DxtradeOrdersHistoryQuery) => {
  const apiClient = useApiClient(ClientApiClient)
  const withOrderIds = query?.withOrderIds
  const withOrderIdsKey = Array.isArray(withOrderIds) ? withOrderIds.join(',') : withOrderIds

  const queryParams = {
    status: query?.status,
    side: query?.side,
    ofType: query?.ofType,
    positionEffect: query?.positionEffect,
    issuedFrom: query?.issuedFrom,
    issuedTo: query?.issuedTo,
    withOrderIdsKey,
  }

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.trade.dxtrade.ordersHistory(accountCode, queryParams),
    queryFn: () => apiClient.getDxtradeOrdersHistory(accountCode, query),
    enabled: !!accountCode,
  })

  return { data, isLoading }
}
